import React, { forwardRef, useEffect, useState } from 'react';

import { validate } from '@vlabs/shared';
import { Input } from '@vlabs/uikit/components/controls/input';
import { useTranslation } from 'react-i18next';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { usePermissionTagsFilters } from '../usePermissionTagsFilters';

function UserIdFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters } = usePermissionTagsFilters();
  const uuidValidationResult = validate.UUIDValidator()(localValue);
  const hasValidationError = uuidValidationResult !== true;
  let validationErrorMessage: string | undefined;
  if (hasValidationError) validationErrorMessage = uuidValidationResult;

  const onChangeHandler = (userId: string) => {
    setLocalValue(userId);

    if (!userId) {
      updateFilters({ created_by_user: undefined });
      return;
    }

    if (validate.isUUID(userId)) updateFilters({ created_by_user: userId });
  };

  useEffect(() => {
    setLocalValue(filters?.created_by_user ?? '');
  }, [filters.created_by_user]);

  const reset = () => {
    setLocalValue('');
    updateFilters({ created_by_user: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      data-testid="created_by_user"
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('entities:permission_tags_filters.created_by_user.popover_title')}</div>}
    >
      <Input
        errorMessage={validationErrorMessage}
        hasError={hasValidationError}
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserIdFilterPopoverWithRef = forwardRef(UserIdFilterPopover);
export { UserIdFilterPopoverWithRef as UserIdFilterPopover };
